/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from './core/BaseHttpRequest';
import type { OpenAPIConfig } from './core/OpenAPI';
import { FetchHttpRequest } from './core/FetchHttpRequest';

import { AuthzSettingsService } from './services/AuthzSettingsService';
import { HirePermissionsProcessesService } from './services/HirePermissionsProcessesService';
import { MatricesService } from './services/MatricesService';
import { PermissionsService } from './services/PermissionsService';
import { PermissionsProcessesService } from './services/PermissionsProcessesService';
import { RolesService } from './services/RolesService';
import { RolesProcessesService } from './services/RolesProcessesService';
import { SelfServeFirstEmployerClaimsProcessesService } from './services/SelfServeFirstEmployerClaimsProcessesService';
import { ServiceService } from './services/ServiceService';
import { SystemProcessesService } from './services/SystemProcessesService';

type HttpRequestConstructor = new (config: OpenAPIConfig) => BaseHttpRequest;

export class AppClient {

  public readonly authzSettings: AuthzSettingsService;
  public readonly hirePermissionsProcesses: HirePermissionsProcessesService;
  public readonly matrices: MatricesService;
  public readonly permissions: PermissionsService;
  public readonly permissionsProcesses: PermissionsProcessesService;
  public readonly roles: RolesService;
  public readonly rolesProcesses: RolesProcessesService;
  public readonly selfServeFirstEmployerClaimsProcesses: SelfServeFirstEmployerClaimsProcessesService;
  public readonly service: ServiceService;
  public readonly systemProcesses: SystemProcessesService;

  public readonly request: BaseHttpRequest;

  constructor(config?: Partial<OpenAPIConfig>, HttpRequest: HttpRequestConstructor = FetchHttpRequest) {
    this.request = new HttpRequest({
      BASE: config?.BASE ?? 'http://localhost:8114',
      VERSION: config?.VERSION ?? '1.0.0',
      WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
      CREDENTIALS: config?.CREDENTIALS ?? 'include',
      TOKEN: config?.TOKEN,
      USERNAME: config?.USERNAME,
      PASSWORD: config?.PASSWORD,
      HEADERS: config?.HEADERS,
      ENCODE_PATH: config?.ENCODE_PATH,
    });

    this.authzSettings = new AuthzSettingsService(this.request);
    this.hirePermissionsProcesses = new HirePermissionsProcessesService(this.request);
    this.matrices = new MatricesService(this.request);
    this.permissions = new PermissionsService(this.request);
    this.permissionsProcesses = new PermissionsProcessesService(this.request);
    this.roles = new RolesService(this.request);
    this.rolesProcesses = new RolesProcessesService(this.request);
    this.selfServeFirstEmployerClaimsProcesses = new SelfServeFirstEmployerClaimsProcessesService(this.request);
    this.service = new ServiceService(this.request);
    this.systemProcesses = new SystemProcessesService(this.request);
  }
}

